<template>
  <div class="fullw">
    <div class="filterbody">
      <div class="mainform" ref="mainform">
        <FormElement
          v-for="(el,key) in form"
          :key="key" 
          :label="el.label"
          :index="el.index"
          :options="el.options" 
          :errors="el.errors"
          :type="el.type"
          @update:modelValue="value => onInputChange(value,key)"
          :model-value="form[key].value"
          v-model="form[key].value" />
        <IpadFormCalendars
          :currentweek="currentweek"
          :selectedOption="selectedOption" />  
        <ErrorsForm 
          :msgs="getMessages()"
          :errors="getErrors()"/>
      </div>
      <div class="btngrid">
        <SearchButton 
          class="sbtn"
          :text="$t('pesquisar')"
          :canSearch="canSearch"
          @click="searchHorario" />
      </div>
    </div>
  </div>
</template>

<script>
import SearchButton from '@/components/buttons/searchButton.vue';
import FormElement from '@/components/FormElement.vue';
import DatePicker from '@/components/datepicker/datepicker.vue';
import ErrorsForm from '@/components/errorForms.vue';
import IpadFormCalendars from '@/containers/desktop/ipadFormCalendars.vue';

export default {
  name: "FilterForm",
  props:["currentweek","selectedOption","form","backtext"],
  emits:["submitForm","input-change","dateChange"],
  components: {
    SearchButton,
    FormElement,
    DatePicker,
    ErrorsForm,
    IpadFormCalendars
  }, 
  computed: {
    canSearch() {
      return Object.values(this.form).every(field => 
        !field.required || (field.required && field.value != null)
      );
    }
  },
  methods: {
    getMessages(){
      let messages = [];
      Object.entries(this.form).forEach(([key, value]) => {
        if(value.msgs.length > 0){
          messages.push(this.form[key].label);
        }
      });
      return messages;
    },
    getErrors(){
      let errors = [];
      Object.entries(this.form).forEach(([key, value]) => {
        if(value.errors.length > 0){
          errors.push(this.form[key].label); 
        }
      });
      return errors;
    },
    onInputChange(value,key){
      this.$nextTick(() => {
        this.$emit('input-change', value, key);
      })
    },
    searchHorario() {
      this.$emit("submitForm",this.selectedDates);
    },
  }
}
</script>

<style>
@media only screen and (max-width: 767px) {
  .dropdown-pane.notop#grauDropDown {
    top: 40px;
  }
  .dropdown-pane .drop.nopaddingtop{
    padding-top: 0;
  }
}
</style>

<style scoped>
.fullw{
  padding-left: 30px;
  padding-right: 30px;
}
.sbtn{
  margin-left: 45px;
  margin-right: 45px;
}

.btngrid {
  margin-top: 20px;
  display: flex;
  justify-content: end;
  width: 100%;
}

.filterbody{
  overflow-y: auto;
  height: calc(100vh - 94.5px - 87px);
  padding-bottom: 40px;
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

.mainform{
  padding-right: 45px;
  padding-left: 45px;
}

@media only screen and (max-width:1600px) {

  .sbtn{
    margin-right: 0px;
  }

  .mainform {
    padding-right: 5px;
  }

}

@media only screen and (max-width:1450px) {

  .mainform {
    padding-left: 15px;
  }

  .sbtn{
    margin-right: 0px;
    margin-left: 10px;
  }
  }


@media only screen and (max-width:1200px) {
  .mainform {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sbtn {
    margin-right: 0px;
    margin-left: 0px;
  }
  
}


@media screen and (max-width: 1024px) {

  .fullw{
    padding-left: 15px;
    padding-right: 15px;
  }

  .mainform{
    padding-right: 5px;
    padding-left: 5px;
  }
}

@media only screen and (max-width:767px) {
  .fullw, .mainform{
    padding-left: 0;
    padding-right: 0;
  }
}



</style>